export default __webpack_public_path__ + "ae9170759c3120402f62a9b3976e7c78.png";